import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tournament-laurel-wrap" }
const _hoisted_2 = ["innerHTML"]

import { marked } from 'marked'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'


export enum TOURNAMENT_LAUREL_STATE {
  HISTORY = 'history',
  FINISHED = 'finished',
  RUNNING = 'running',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CTournamentLaurel',
  props: {
    prevBestScore: {},
    score: {},
    rank: {},
    state: {}
  },
  setup(__props: any) {

const props = __props
const { t } = useI18n()

const text = computed(() => {
  const bestScorePartial =
    props.prevBestScore !== null
      ? ` ${t('tViews.joined.text_tournamentInfo_bestScorePartial', { prevBestScore: props.prevBestScore })}, `
      : ''
  const text = t('tViews.joined.text_tournamentInfo_' + props.state, {
    score: props.score,
    bestScorePartial: bestScorePartial,
    rank: props.rank,
  })
  return marked(text)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["tournament-laurel", `tournament-laurel-${_ctx.state}`])
    }, [
      _createElementVNode("div", {
        class: "tournament-laurel-text",
        innerHTML: text.value
      }, null, 8, _hoisted_2)
    ], 2)
  ]))
}
}

})